<template>
  <base-modal @close="$emit('close')">
    <template #heading>
      Upload {{ type === 'profile' ? 'Profile' : 'Cover' }} Photo
    </template>
    <p class="content_policy">
      Make sure your photos follow Google’s guidelines and requirements,
      and comply with
      <a
        href="https://support.google.com/business/answer/10693375"
        target="_blank"
      >
        Google's content policy.
      </a>
    </p>

    <div
      v-if="type === 'profile'"
      class="guidelines"
    >
      <strong>Profile Photo:</strong> a photo to help customers easily identify your business. Recommended Size – 250 x
      250 pixels (minimum 120 x 120 pixels; maximum 5200 x 5300 pixels)
    </div>

    <div
      v-if="type === 'cover'"
      class="guidelines"
    >
      <strong>Cover Photo:</strong> your business’ preferred photo. Though it’s preferred, it doesn’t guarantee that
      this image will populate as the first image on your listing. Recommended Size - 1080 x 608 pixels
      (minimum 480 x 270 pixels; maximum 2120 x 1192 pixels)
    </div>

    <dropzone-area
      :additional-xhr-data="{category}"
      :endpoint="`/gbp/upload-media-item/${selectedLocation}`"
      :limit="1"
      accepted-files="image/png, image/jpg, image/jpeg"
      invalid-file-type-message="Google does not accept this file type"
      @close="$emit('close')"
    />
  </base-modal>
</template>

<script>
import BaseModal from "../../../global/modals/BaseModal";
import DropzoneArea from "../../../global/forms/DropzoneArea";
import {mapGetters} from "vuex";

export default {
  components: {
    DropzoneArea,
    BaseModal,
  },
  props: {
    type: {
      type: String,
      required: true,
      validator(value) {
        return ['cover', 'profile'].includes(value);
      }
    }
  },
  emits: ['close'],
  data() {
    return {
      showGuidelines: false,
      mediaCategory: null,
    }
  },
  computed: {
    ...mapGetters('businessProfile', [
      'selectedLocation',
    ]),
    category() {
      return this.type.toUpperCase();
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.content_policy {
  margin: 0 .5rem;
}

.guidelines {
  margin: 1rem .5rem;
}
</style>
